import { BigNumber } from '@ethersproject/bignumber';
export var PERMIT2_ADDRESS = '0x000000000022D473030F116dDEE9F6B43aC78BA3';
export var MaxUint48 = BigNumber.from('0xffffffffffff');
export var MaxUint160 = BigNumber.from('79228162514264337593543950335');
export var MaxUint256 = BigNumber.from('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff');
// alias max types for their usages
// allowance transfer types
export var MaxAllowanceTransferAmount = MaxUint160;
export var MaxAllowanceExpiration = MaxUint48;
export var MaxOrderedNonce = MaxUint48;
// signature transfer types
export var MaxSignatureTransferAmount = MaxUint256;
export var MaxUnorderedNonce = MaxUint256;
export var MaxSigDeadline = MaxUint256;
export var InstantExpiration = BigNumber.from(0);
